import { driver } from "driver.js";
import "driver.js/dist/driver.css";

export const startProjectTour = (hasProjects) => {
  // 1. Define steps that ALWAYS appear (for everyone)
  const onboardingSteps = [
    {
      element: "#create-project",
      popover: {
        title: "Start a New Project",
        description:
          "Begin your journey here. Click to set up a new workspace and define your project goals.",
      },
      disableActiveInteraction: true,
    },
  ];

  // 2. Define steps that ONLY appear if projects exist
  const projectSteps = [
    {
      element: "#connected-projects",
      popover: {
        title: "Integrations Dashboard",
        description:
          "View all your linked accounts. Both Google Ads and Bing Ads are supported for seamless syncing.",
      },
    },
    {
      element: "#project-name",
      popover: {
        title: "Project Access",
        description:
          "Click the project name to enter your dashboard and view detailed analytics.",
      },
    },
    {
      element: "#edit-project",
      popover: {
        title: "Project Settings",
        description:
          "Need to make changes? Use this menu to update configurations or remove projects you no longer need.",
      },
    },
    {
      element: "#add-people",
      popover: {
        title: "Team Collaboration",
        description:
          "Invite team members and manage permissions to ensure everyone has the right access.",
      },
    },
    {
      element: "#tasks",
      popover: {
        title: "Task Management",
        description:
          "Stay organized by assigning tasks, setting deadlines, and tracking team progress.",
      },
    },
  ];

  // 3. Combine them logically
  // If hasProjects is true, show everything. If false, only show onboardingSteps.
  const finalSteps = hasProjects
    ? [...onboardingSteps, ...projectSteps]
    : onboardingSteps;

  //   const finalSteps = hasProjects ? projectSteps : onboardingSteps;

  // 4. Initialize Driver
  const driverObj = driver({
    showProgress: true,
    animate: true,
    allowClose: true,
    doneBtnText: hasProjects ? "Finish" : "Got it", // Change text based on context
    nextBtnText: "Next",
    prevBtnText: "Back",
    popoverClass: "my-custom-driver-popover",
    steps: finalSteps, // Inject the dynamic list here

  });

  driverObj.drive();
};
